import { createFileRoute } from "@tanstack/react-router";

import { NspTopicsPanel } from "@/features/nvwa/nsp-topics-panel";

export const Route = createFileRoute("/_authenticated/nvwa/nsp-topics")({
  component: NvwaNspTopicsRoute,
});

function NvwaNspTopicsRoute() {
  return (
    <div className="flex min-h-0 flex-1 flex-col p-6">
      <NspTopicsPanel />
    </div>
  );
}
